import React from "react";
import PageHeader from "../../components/pageHeader";
import {Layout, Button, Col, Row, Form, Input, Table, Icon} from "antd";
import {Manufacturer} from "../../models/manufacturer";
import {connect} from "react-redux";
import actions from "../../redux/manufacturer/actions";
import CheckError from "../../components/checkError";
import DeleteModal from "../../components/deleteModal";
import {Container} from "../Container";
import EditModal from "./EditModal";

const {Content} = Layout;
const {
    getManufacturers,
    deleteManufacturer,
    createManufacturer,
    updateManufacturer,
    importManufacturers,
    getManufacturersPdf,
    getManufacturersCsv
} = actions;

export class ManufacturersContainer extends Container {

    state = {
        editModalVisible: false,
        editModalTitle: '',
        deleteModalVisible: false,
        manufacturer: {},
        fullText: ''
    };

    resource = 'manufacturers';
    model = new Manufacturer();
    getResource = (params) => {
        this.props.getManufacturers(params);
    };

    componentDidMount() {
        if (this.props.manufacturers.fullText !== this.state.fullText) {
            this.setState({fullText: this.props.manufacturers.fullText});
        }
        this.getResource(this.props[this.resource]);
    };

    /**
     * Drukuje dane
     */
    print = () => {
        this.props.getManufacturersPdf({});
    }

    /**
     * Pobiera dane
     */
    download = () => {
        this.props.getManufacturersCsv({});
    }

    /**
     * @description Otwiera okno usuwania danych
     */
    showDeleteModal = (record) => {
        this.setState({
            manufacturer: record,
            deleteModalVisible: true
        });
    }

    /**
     * @description Usuwa dane
     */
    handleDeleteOk = () => {
        this.props.deleteManufacturer(this.state.manufacturer.id);
        this.setState({
            manufacturer: {},
            deleteModalVisible: false
        });
    }

    /**
     * @description Anuluje usuwanie danych
     */
    handleDeleteCancel = () => {
        this.setState({
            deleteModalVisible: false
        });
    }

    /**
     * Otwiera okno dodawania danych
     * @param record
     */
    showAddModal = (record) => {
        this.setState({
            editModalVisible: true,
            editModalTitle: 'Dodaj producenta',
            manufacturer: new Manufacturer()
        });
    }

    /**
     * Otwiera okno edycji danych
     * @param record
     */
    showEditModal = (record) => {
        this.setState({
            editModalVisible: true,
            editModalTitle: 'Edytuj producenta ' + record.name,
            manufacturer: record
        });
    }

    /**
     * Zapisuje dane
     */
    handleSave = () => {
        const form = this.editFormRef.props.form;
        form.validateFields((err, values) => {
            //przerwanie procesu w przypadku wystąpienia błędów na formularzu
            if (err) {
                return;
            }
            //console.log(values);
            //wysyłka danych do serwera
            const m = new Manufacturer();
            if (this.state.manufacturer.id) {
                this.props.updateManufacturer(this.state.manufacturer.id, m.getData(values));
            } else {
                this.props.createManufacturer(m.getData(values));
            }

            //console.log('Received values of form: ', m.getData(values));

            //wyczyszczenie formularza
            form.resetFields();

            //zamknięcie okna edycji
            this.setState({
                editModalVisible: false
            });
        });
    }

    /**
     * Anuluje edycję danych
     */
    handleCancel = () => {
        this.setState({
            editModalVisible: false
        });
    }

    /**
     * Uruchomienie filtra i zamknięcie okienka
     * (właściwe fitrowanie obługiwane jest przez metodę handleTableChange)
     * @param selectedKeys
     * @param confirm
     */
    handleSearch = (selectedKeys, confirm) => {
        confirm();
    }

    /**
     * Wyczyszczenie filtra i zamknięcie okienka
     * (właściwe czyszczenie fitra obługiwane jest przez metodę handleTableChange)
     * @param clearFilters
     */
    handleReset = (clearFilters) => {
        clearFilters();
    }

    handleResetFullText = () => {
        this.setState({fullText: ''}, () => {
            this.filterFullText('');
        });
    };

    handleKeyDownFullText = (e) => {
        if (e.key === 'Enter') {
            this.filterFullText(this.state.fullText);
        }
    }

    /**
     * Zwraca referencję do formularza edycji
     * @param formRef
     */
    saveEditFormRef = (formRef) => {
        this.editFormRef = formRef;
    }

    importManufacturers = () => {
        this.props.importManufacturers();
    }

    render() {
        const columns = [{
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            sorter: true,
            defaultSortOrder: this.props[this.resource].sort.id || null,
            filteredValue: this.props[this.resource].filters.id || null,
            ...this.getColumnSearchProps('id'),
        }, {
            title: 'Nazwa',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            defaultSortOrder: this.props[this.resource].sort.name || null,
            filteredValue: this.props[this.resource].filters.name || null,
            ...this.getColumnSearchProps('name'),
        }, {
            title: 'Nazwa SEO',
            dataIndex: 'seo_name',
            key: 'seo_name',
            sorter: false,
        }, {
            title: 'Liczba modeli',
            dataIndex: 'model_count',
            key: 'model_count',
            sorter: false,
        }, {
            title: 'Akcje',
            key: 'action',
            render: (text, record) => (
                <Button.Group>
                    <Button type="primary" icon="edit" title="Edytuj" onClick={(e) => {
                        this.showEditModal(record);
                        e.stopPropagation();
                    }}></Button>
                    <Button type="primary" icon="delete" title="Usuń" onClick={(e) => {
                        this.showDeleteModal(record);
                        e.stopPropagation();
                    }}></Button>
                </Button.Group>
            ),
        }
        ];
        return <div>
            <Layout style={{padding: '0 24px 24px'}}>
                <PageHeader>Producenci</PageHeader>
                <Content style={{
                    background: '#fff',
                    padding: 24,
                    margin: 0,
                }}>
                    <Row>
                        <Col span={4}>
                            <Button.Group>
                                <Button icon="printer" onClick={this.print} title="Drukuj"></Button>
                                <Button icon="download" onClick={this.download}
                                        title="Pobierz"></Button>
                                <Button icon="reload" onClick={this.refresh}
                                        title="Odśwież"></Button>
                            </Button.Group>
                        </Col>
                        <Col span={20} style={{textAlign: 'right'}}>
                            <Form layout="inline">
                                <Form.Item>
                                    <Input
                                        placeholder="Szukaj"
                                        value={this.state.fullText}
                                        onChange={(e) => this.setState({fullText: e.target.value})}
                                        onKeyDown={this.handleKeyDownFullText}
                                        suffix={<Icon type="close"
                                                      onClick={this.handleResetFullText}/>}
                                        addonAfter={<Icon type="search"
                                                          onClick={(e) => this.filterFullText(this.state.fullText)}/>}
                                    />
                                </Form.Item>

                                <Form.Item>
                                    <Button type="default" icon="plus" onClick={this.showAddModal}>Dodaj</Button>
                                </Form.Item>

                                <Form.Item>
                                    <Button type="primary" icon="import" onClick={this.importManufacturers}
                                            title="Importuj">Importuj</Button>
                                </Form.Item>
                            </Form>
                        </Col>
                    </Row>
                </Content>

                <Content style={{
                    background: '#fff',
                    padding: 24,
                    margin: 0,
                }}>
                    <CheckError error={this.props.manufacturers.error} history={this.props.history}/>
                    <Table
                        pagination={{
                            ...this.props.manufacturers.pagination,
                            pageSizeOptions: ['5', '10', '20'], // ręczna opcja liczby wyświetlanych rekordow na stronie
                            showSizeChanger: true,
                            showQuickJumper: true,
                            showTotal: this.showTotalItemsDialog,
                        }}
                        columns={columns}
                        dataSource={this.props.manufacturers.items}
                        loading={this.props.manufacturers.loading}
                        rowKey="id"
                        onChange={this.handleTableChange}
                        onRow={(record) => {
                            return {
                                onClick: () => {
                                    //history.push(this.props.url + '/' + record.id)
                                },
                                onMouseEnter: () => {
                                },  // mouse enter row
                            };
                        }
                        }
                    />

                    <EditModal
                        wrappedComponentRef={this.saveEditFormRef}
                        title={this.state.editModalTitle}
                        visible={this.state.editModalVisible}
                        onSave={this.handleSave}
                        onCancel={this.handleCancel}
                        data={this.state.manufacturer}
                    >
                    </EditModal>

                    <DeleteModal
                        title="Usuwanie danych producenta"
                        content={<div><p>Czy na pewno usunąć dane producenta: <i>{this.state.manufacturer.name}</i>?</p>
                        </div>}
                        visible={this.state.deleteModalVisible}
                        onDelete={this.handleDeleteOk}
                        onCancel={this.handleDeleteCancel}
                    >
                    </DeleteModal>
                </Content>
            </Layout>
        </div>;
    }
}

const mapStateToProps = (state) => ({
    manufacturers: state.Manufacturers
});

export default connect(mapStateToProps, {
    getManufacturers,
    deleteManufacturer,
    createManufacturer,
    updateManufacturer,
    importManufacturers,
    getManufacturersPdf,
    getManufacturersCsv
})(ManufacturersContainer);
